import { CmCompanyType, CmDetailsDataStructure } from 'components/DetailsPageBoilerplate/types';
import { CommissionTerm, FIELDS, RADIO_VALUES } from '../types';
import { filterCommissionTermsByType, formatAddress, mapAdmins, produceNewTerm } from '../utils';
import { formatFullAddressOld } from 'utils/address';
import { format } from 'utils/date';
import { formatDueDiligenceStatus } from 'screens/Panel/dueDiligence/formatter';
import { COMMISSION_TERM_TYPE } from '../../../modules/commission_terms/api/types';

export const getClubName = (club: CmCompanyType | undefined): string => {
  return club ? club.name : '';
};

export const mapInitialData = (data: CmDetailsDataStructure) => {
  const { admins, company } = data;
  const DATE_FORMAT = 'DD/MM/YYYY';

  return {
    [FIELDS.CLUB_NAME]: company.name,
    [FIELDS.FCA]: company.fcaNumber,
    [FIELDS.REGISTER_DATE]: company.registeredAt ? format(company.registeredAt).dateTime(DATE_FORMAT) : '',

    [FIELDS.ADDRESS]: formatAddress(company.address),
    [FIELDS.FULL_ADDRESS]: formatFullAddressOld(company.address),
    [FIELDS.EMAIL]: company.email,
    [FIELDS.PHONE]: company.phone,

    admins: mapAdmins(admins),

    [FIELDS.STANDARD_COMMISSION_TERMS]:
      filterCommissionTermsByType(company.commissionTerms, COMMISSION_TERM_TYPE.STANDARD).length > 0
        ? company.commissionTerms
            .filter((term) => term.type === COMMISSION_TERM_TYPE.STANDARD)
            .map((term) => term.id.toString())
        : [produceNewTerm()],
    [FIELDS.ENHANCED_UPFRONT_COMMISSION_TERMS]:
      filterCommissionTermsByType(company.commissionTerms, COMMISSION_TERM_TYPE.ENHANCED).length > 0
        ? company.commissionTerms
            .filter((term) => term.type === COMMISSION_TERM_TYPE.ENHANCED)
            .map((term) => term.id.toString())
        : [produceNewTerm()],
    [FIELDS.ONGOING_COMMISSION_TERMS]:
      filterCommissionTermsByType(company.commissionTerms, COMMISSION_TERM_TYPE.ONGOING).length > 0
        ? company.commissionTerms
            .filter((term) => term.type === COMMISSION_TERM_TYPE.ONGOING)
            .map((term) => term.id.toString())
        : [produceNewTerm()],

    [FIELDS.FCA_STATUS]: company.fcaStatus ? RADIO_VALUES.ACTIVE : RADIO_VALUES.INACTIVE,
    [FIELDS.LMC_STATUS]: company.lmcStatus ? RADIO_VALUES.ACTIVE : RADIO_VALUES.INACTIVE,
    [FIELDS.DD_STATUS]: formatDueDiligenceStatus(company.dueDiligenceStatus),
  };
};

export const mapResources = (resources: any) => {
  const mapCommissionTerm = (term: CommissionTerm) => ({
    value: term.id.toString(),
    type: term.type.toString(),
    option: term.name,
  });
  return {
    standardCommissionTerms: resources.commission_terms
      .filter((term: CommissionTerm) => term.type === COMMISSION_TERM_TYPE.STANDARD)
      .map(mapCommissionTerm),
    ongoingCommissionTerms: resources.commission_terms
      .filter((term: CommissionTerm) => term.type === COMMISSION_TERM_TYPE.ONGOING)
      .map(mapCommissionTerm),
    enhancedCommissionTerms: resources.commission_terms
      .filter((term: CommissionTerm) => term.type === COMMISSION_TERM_TYPE.ENHANCED)
      .map(mapCommissionTerm),
  };
};
